function OpenAILogo({ active }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-5 w-5 ${active ? 'text-white' : 'text-zinc-500'}`} fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 3.6a3.8 3.8 0 0 1 3.3 1.9l.7 1.2 1.3-.1a3.8 3.8 0 0 1 3.7 5.4l-.6 1.2.8 1a3.8 3.8 0 0 1-2.8 6.2h-1.4l-.6 1.2a3.8 3.8 0 0 1-6.8 0l-.6-1.2H7.7a3.8 3.8 0 0 1-2.8-6.2l.8-1-.6-1.2a3.8 3.8 0 0 1 3.7-5.4l1.3.1.7-1.2A3.8 3.8 0 0 1 12 3.6Z" />
      <circle cx="12" cy="12" r="2.3" />
    </svg>
  );
}

function GeminiLogo({ active }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-5 w-5 ${active ? 'text-white' : 'text-zinc-500'}`} fill="currentColor">
      <path d="M12 2.5c.7 4.2 1.9 5.4 6 6.1-4.1.7-5.3 1.9-6 6.1-.7-4.2-1.9-5.4-6-6.1 4.1-.7 5.3-1.9 6-6.1Zm6.2 11.6c.4 2.4 1 3 3.3 3.4-2.3.4-2.9 1-3.3 3.4-.4-2.4-1-3-3.3-3.4 2.3-.4 2.9-1 3.3-3.4Z" />
    </svg>
  );
}

function AnthropicLogo({ active }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-5 w-5 ${active ? 'text-white' : 'text-zinc-500'}`} fill="currentColor">
      <path d="M11.2 4 5.2 20h2.7l1.2-3.4h5.7L16 20h2.8L12.8 4h-1.6Zm.8 4.1 1.9 5.3H10L12 8.1Z" />
    </svg>
  );
}

function ProviderLogo({ provider, active }) {
  if (provider === 'openai') return <OpenAILogo active={active} />;
  if (provider === 'gemini') return <GeminiLogo active={active} />;
  return <AnthropicLogo active={active} />;
}

export function ChatModelPicker({ options, selectedModels, onToggleModel, rightSlot }) {
  return (
    <div className="space-y-2" data-testid="chat-model-picker">
      <div className="flex flex-wrap items-center gap-3">
        {options.map((option) => {
          const active = selectedModels.includes(option.key);
          return (
            <button
              key={option.key}
              type="button"
              data-testid={`model-selector-${option.key}`}
              aria-pressed={active}
              onClick={() => onToggleModel(option.key)}
              className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-all ${
                active
                  ? 'border-white bg-white/10 text-white'
                  : 'border-zinc-800 bg-zinc-950/60 text-zinc-500 hover:border-zinc-600 hover:text-zinc-300'
              }`}
            >
              <span className={active ? '' : 'opacity-60'}>
                <ProviderLogo provider={option.provider} active={active} />
              </span>
              <span>{option.shortLabel}</span>
            </button>
          );
        })}
        {rightSlot ? <div className="ml-auto">{rightSlot}</div> : null}
      </div>
      <p className="text-xs text-zinc-500">Sélection active : {selectedModels.length} modèle{selectedModels.length > 1 ? 's' : ''}</p>
    </div>
  );
}
